<template>
  <div class="page" :style="isGlobal ? { padding: '1rem'} : ''">
    <h2 v-if="!isGlobal">Мои записи</h2> <h2 v-else>Все мои записи</h2>
    <b-tabs content-class="mt-3" justified>
    <b-tab @click="getAppoints" title="Завершенные" active>
      <div style="padding-bottom:2rem" v-if="appointments.length > 0">
        <CustomList v-for="obj in appointments" :key="obj.id" :item="obj" :loading="loading" :avatar="obj.doctor.employee.avatar" :withRightSide="true">
          <template slot="info">
             <div class="title">{{ obj.doctor.employee.last_name }} {{ obj.doctor.employee.first_name }} {{ obj.doctor.employee.middle_name }}</div>
            <div v-if="obj.doctor" class="subtitle">Запись на: {{ obj.time }}</div>
            <div v-if="obj.doctor" class="subtitle">Стаж {{ obj.doctor.experience }} / {{ obj.doctor.specialty.title }}</div>
            <div v-if="obj.doctor" class="subtitle"><span v-if="isGlobal && obj.organization" style="font-weight: 500;">{{ obj.organization.title }} / </span> {{obj.doctor.department.title}}</div>
            <div v-if="obj.organization" class="subtitle">Адрес: {{ obj.organization.city}}, {{ obj.organization.address }}</div>
          </template>
          <template slot="rightSideInfo">
            <a
            v-if="obj.conversation"
            class="vm-button"
            @click="$router.push({ name: 'vuexchatroom', params: { id: isGlobal ? obj.conversation.id : obj.conversation }});"
          >
            Чат
          </a>
          </template>
        </CustomList>
      </div>
      <div style="text-align:center" v-else>
        <div v-if="loading">
          <div
            v-for="item in loadingItems"
            :key="item"
            class="vm-history-item vm-history-item-loading" style="justify-content:center"
          >
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
      </div>
        <span v-else>Нет записей</span>
      </div>
      
      
    </b-tab>
    <b-tab @click="getFutureAppoint" title="Предстоящие">
      <div style="padding-bottom:2rem" v-if="commingAppoints.length > 0">
      <CustomList v-for="obj in commingAppoints" :key="obj.id" :item="obj" :loading="loading" :avatar="obj.doctor.employee.avatar">
        <div slot="info">
          <div class="title">{{ obj.doctor.employee.last_name }} {{ obj.doctor.employee.first_name }} {{ obj.doctor.employee.middle_name }}</div>
          <div v-if="obj.doctor" class="subtitle">Запись на: {{ dateTime(obj) }}</div>
          <div v-if="obj.doctor" class="subtitle">Стаж {{ obj.doctor.experience }} / {{ obj.doctor.specialty.title }}</div>
          <div v-if="obj.doctor" class="subtitle"><span v-if="isGlobal && obj.organization" style="font-weight: 500;">{{ obj.organization.title }} / </span> {{obj.doctor.department.title}}</div>
            <div v-if="obj.organization" class="subtitle">Адрес: {{ obj.organization.city}}, {{ obj.organization.address }}</div>
        </div>
        <template slot="rightSideInfo">
          <a v-b-tooltip.hover="'Отменить запись'" class="link-close" @click="openDialog(obj)">
            <span class="material-icons">close</span>
          </a>
          <a
            v-if="obj.type===1"
            class="vm-button"
            @click="$router.push({ name: 'vuexchatroom', params: { id: isGlobal ? obj.conversation.id : obj.conversation }});"
          >
            Чат
          </a>
        </template>
      </CustomList>
      </div>
      <div style="text-align:center" v-else>
        <div class="items" v-if="loading">
          <div
            v-for="item in loadingItems"
            :key="item"
            class="vm-history-item vm-history-item-loading" style="justify-content:center"
          >
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
      </div>
        <span v-else> Нет записей </span>
      </div>
      
    
    </b-tab>
    <b-tab @click="getCancelAppoint" title="Отмененные" v-if="!isGlobal">
      <div style="padding-bottom:2rem" v-if="cancelAppoints.length > 0">
      <CustomList v-for="obj in cancelAppoints" :key="obj.id" :item="obj" :loading="loading" :avatar="obj.doctor.employee.avatar">
        <div slot="info">
          <div class="title">{{ obj.doctor.employee.last_name }} {{ obj.doctor.employee.first_name }} {{ obj.doctor.employee.middle_name }}</div>
          <div v-if="obj.doctor" class="subtitle">Запись на: {{ dateTime(obj) }} отменен</div>
          <div v-if="obj.doctor" class="subtitle">Стаж {{ obj.doctor.experience }} / {{ obj.doctor.specialty.title }}</div>
          <div v-if="obj.doctor" class="subtitle">{{ obj.doctor.department.title }}</div>
        </div>
        <div slot="rightSideInfo">
          Запись отменена
        </div>
      </CustomList>
      </div>
      <div style="text-align:center" v-else>
        <div class="items" v-if="loading">
          <div
            v-for="item in loadingItems"
            :key="item"
            class="vm-history-item vm-history-item-loading" style="justify-content:center"
          >
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
      </div>
        <span v-else> Нет записей</span>
      </div>
      
      
    </b-tab>
  </b-tabs>
  <Dialog v-model="deleteSlotOpen">
    <div>
        <div class="modal-header">
                  <h3>Удалить запись?</h3>      
        </div>
        <div class="modal-body">
          Вы дествительно хотите удалить запись на {{removeInfo}}?
        </div>
        <div class="modal-footer">
                  <button class="btn btn-sm btn-secondary" @click="deleteSlotOpen=false">
                    Отмена
                  </button>
                  <button class="btn btn-sm btn-danger" @click="unsubscribeSlot()">
                    Удалить
                  </button>
        </div>
    </div>
  </Dialog>
</div>
</template>

<script>
import { http, patientApi, timetableApi } from '../../../services';
import moment from 'moment';
import toastr from 'toastr';
import Dialog from '@app/components/uikit/Dialog';
import CustomList from '@app/components/uikit/CustomList';

export default {
  components: {
    Dialog, CustomList
  },
  data: () => ({
    appointments: [],
    commingAppoints: [],
    cancelAppoints: [],
    itemWidth: 0,
    deleteSlotOpen: false,
    removeInfo: '',
    removeItem: {},
    loading: false,
    loadingItems: Array.from(new Array(1)).map((v, i) => i),
    isGlobal: false,
    currentApiKey: ''
  }),
  async created() {
    this.isGlobal = this.$route.name === 'index.recordspage' ? true : false;
    this.getAppoints();
  },
  mounted() {
    moment.locale('ru');
  },
  
  methods: {
    openDialog(item) {
      if (this.isGlobal) {
        this.currentApiKey = item.organization.id;
      }
      this.deleteSlotOpen = true;
      this.removeItem = item;
      this.removeInfo = `${moment(item.start_time).format('DD.MM.YYYY LT')}-${moment(item.end_time).format('LT')}`;
    },
    unsubscribeSlot() { 
      const appoint = this.removeItem;
      this.deleteSlotOpen = false;
      if (this.isGlobal) {
        http.setApiKey(this.currentApiKey);
      }
      timetableApi.update(appoint.id, {patient: null, is_reserve: false}).then(res => {
        this.getFutureAppoint();
        this.removeItem = {};
      }).catch(error => {
        this.removeItem = {};
        this.$bvToast.toast(error, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      });
    },
    async getAppoints() {
      this.loading = true;
      this.appointments = [];
      const { items } = await patientApi.getSlots({with_reception: 1}, this.isGlobal);
      this.appointments = items.map(({ id, doctor, conversation, organization, start_time, end_time, status, timeslot }) => {
        const name = `${doctor.employee.last_name} ${doctor.employee.first_name} ${doctor.employee.middle_name}`;
        const time = `${moment(start_time).format('DD.MM.YYYY LT')}-${moment(
          end_time
        ).format('LT')}`;
        return {
          id,
          name,
          doctor,
          conversation,
          organization,
          time,
          specialty: doctor.specialty.title,
          status
      };
    });
    this.loading = false;
    },
    getFutureAppoint() {
      this.loading = true;
      this.commingAppoints = [];
        patientApi.getSlots({ start_time: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')}, this.isGlobal).then(res => {
            this.commingAppoints = res.items;
            this.loading = false;

        }).catch(error => {
            this.loading = false;
            toastr.error(error);
        });
    },
    getCancelAppoint() {
      this.loading = true;
      this.cancelAppoints = [];
        patientApi.getSlots({ cancel_reception: 1}).then(res => {
            this.cancelAppoints = res.items;
            this.loading = false;
        }).catch(error => {
            this.loading = false;
            toastr.error(error);
        });
    },
    dateTime(item) {
      return `${moment(item.start_time).format('DD.MM.YYYY LT')}-${moment(item.end_time).format('LT')}`;
    }
  }
};
</script>

<style scoped>
h2 {
  color: #727272;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}
.vm-card {
  border-radius: 4px;
  background-color: white;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.vm-history-empty {
  font-size: 1.2em;
  font-weight: 300;
  text-align: center;
  color: #6c757d;
}
.vm-history-item {
  padding: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  display: flex;
}
.vm-history-item:last-child {
  border-bottom: 0;
}
.vm-history-doctor {
  margin-right: auto;
}
.vm-history-doctor-name {
  font-size: 1.5rem;
  color: #212529;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}
.vm-history-doctor-specialty {
  color: #6c757d;
}
.vm-history-timestamp {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.vm-history-timestamp-label {
  color: #6c757d;
  font-size: 0.8rem;
}

.vm-history-timestamp-value {
  color: #6cbdee;
  font-weight: 600;
}
.vm-history-item-loading .vm-history-doctor-specialty {
  width: 150px;
  height: 24px;
}
.vm-history-item-loading .vm-history-doctor-name {
  width: 350px;
  height: 28px;
}
.vm-history-item-loading .vm-history-timestamp-value {
  width: 200px;
  height: 24px;
}
.loading-block {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #ececec;
  background: linear-gradient(to right, #f7f7f7 8%, #ececec 38%, #f7f7f7 54%);
  background-size: 1000px 640px;
  position: relative;
}
.active {
  background: linear-gradient(to right, rgba(137, 48, 216, 0.4), rgba(92, 72, 212, 0.3));
}
::v-deep .nav-item .nav-link {
    background: #9735ee;
    margin:2px;
    color: gainsboro;
}
::v-deep .mt-3, .my-3 {
  margin-top: 0 !important;
}
::v-deep .nav-link.active {
    background: linear-gradient(to right, rgba(137, 48, 216, 0.4), rgba(92, 72, 212, 0.3));
    border: none;
}
::v-deep .nav-tabs .nav-link.active {
    color: #9735ee;
    font-weight: 600;
}
::v-deep .nav-tabs .nav-link {
    border: none;
}

.items {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.item {
  width: 80%;
  display: flex;
  margin-top: 1.5rem;
 /* border: 1px solid #dfdfdf;
  border-radius: 0.25rem; */
  background-color: white;
 /* box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.02); */
  transition: background-color 200ms ease;
  overflow: hidden;
}
.item:last-child {
  margin-bottom: 2rem;
}

.item-logo {
  height: 100px;
  overflow: hidden;
  flex: 0 0 100px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
  transform: translate(0px, -15px);
  position: absolute;
  width: 95px;
}
.item-logo img {
  max-width: 100%;
  max-height: 100%;
}
.item-logo svg {
  width: 50px;
  height: 50px;
}

.vm-item-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 160px;
}
.vm-item-info .title {
  font-size: 1.5rem;
  color: #262626;
  margin-bottom: 6px;
  line-height: 1;
}
.vm-item-info .subtitle {
  color: #606368;
  line-height: 1;
}
.vm-item-action {
  margin-left: auto;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
  flex-direction: column;
  justify-content: space-between;
}
.vm-button {
  font-weight: 300;
  background: linear-gradient(to right, #8C30DA, #5C48D4);
  border: 1px solid #dbdbdb;
  border-radius: 25px;
  color: white;
  padding: 0.5rem 3rem;
  transition: all 200ms;
  outline: none;
  text-decoration: none;
}
.vm-button:hover {
  border: 1px solid #6cbdee;
  background-color: #6cbdee;
  color: #000;
  cursor: pointer;
}
.link-close:hover {
  cursor: pointer;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  overflow: auto;
  height: 50%;
}

</style>
